import { TRankIcons } from '../../../../types';

import IconFirstRank from './IconFirstRank';
import IconFlag from './IconFlag';

/**
 * Icons base for `BidRankBadgeOld`. It will help to access icons.
 * eg( `bidRankIcons[firstRank]` )
 * @deprecated - Use `BidRankIcon` instead.
 */
const bidRankIcons: TRankIcons = {
  firstRank: IconFirstRank,
  winningRange: IconFlag,
};

export default bidRankIcons;
